import { Toast } from "primereact/toast";
import { useRef, useState } from "react";

import { IBenchConsultant } from "../../models/BenchConsultant";
import { EmptyBenchConsultant } from "./EmptyBenchConsultant";
import { Form } from "./Form";
import { Table } from "./Table";
import { IPermissionProps } from "../../models/Login";

export interface IModel {
    open: boolean,
    singleData: IBenchConsultant
}

export const BenchConsultant = (permissions: IPermissionProps) => {

    const [modal, setModal] = useState({ singleData: EmptyBenchConsultant, open: false } as IModel);
    const [reload, setReload] = useState(false);
    const toast = useRef<any>(null);

    const hideDialog = () => {
        setModal({ singleData: EmptyBenchConsultant, open: false })
    };


    return (
        <>
            {(permissions.is_Create || permissions.is_Update) && <Form singleData={modal.singleData} open={modal.open} hideDialog={hideDialog} toast={toast} reload={reload} setReload={setReload} modal={modal}></Form>}
            <Table permissions={permissions} setModal={setModal} toast={toast} reload={reload} setReload={setReload}></Table>
            <Toast ref={toast} />
        </>
    );
}
